module.exports = __webpack_public_path__ + "fonts/gothica1-black-webfont.d9020b9.woff2";